import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { api, ApiError } from "@/services/api.ts";
import type { AlertFilters } from "@/types";

export function useAlerts(filters: AlertFilters) {
  const { effectiveCompanyId } = useAuth();
  return useInfiniteQuery({
    queryKey: ["alerts", effectiveCompanyId, filters],
    queryFn: ({ pageParam }) => api.alerts.list(filters, pageParam),
    initialPageParam: null as string | null,
    getNextPageParam: (last) => last.continuation ?? undefined,
    staleTime: 60 * 1000,
    enabled: !!effectiveCompanyId,
  });
}

export function useAlertDrawer(alertId: string | null) {
  const { effectiveCompanyId } = useAuth();
  return useQuery({
    queryKey: ["alertDrawer", effectiveCompanyId, alertId],
    queryFn: () => api.alerts.get(alertId ?? ""),
    staleTime: 60 * 1000,
    enabled: !!effectiveCompanyId && alertId !== null,
    retry: (failureCount, error) => !(error instanceof ApiError && error.status === 404) && failureCount < 2,
  });
}
